/**
 * index.js
 *
 * Main project entry point. Import all the initial scaffolding files here.
 *
 */

// Project-wide JS
import '../2-core-elements/core-elements';
import '../3-components/components';
import '../4-sections/sections';

const setAppHeight = () => {
    const vh = window.innerHeight * 0.01;
    // use --vh var instead of 100vh in css to define full height screen
    // this will fix the issue on 100vh mobile size
    // read more how to use it with css calc on
    // https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
    document.documentElement.style.setProperty('--vh', `${vh}px`);
};
// set vh on window load
window.addEventListener('load', setAppHeight);

// set vh on window resize
window.addEventListener('resize', setAppHeight);
